import React from 'react';
import SwiperCore, { FreeMode, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { swiperConfig } from '@/helpers/utils/swiperConfig';
import { ProducItem } from '../../product/components/productItem';

SwiperCore.use([Pagination, Navigation, FreeMode]);

const AlgoliaRecommendProductsList = (products: any) => {
  return (
    <Swiper {...swiperConfig()} className="mySwiper multiSlide homePageSwiper">
      {products?.item
        ?.filter(
          (items: any, index: any, self: any) =>
            index === self.findIndex((product: any) => product.displayName === items.displayName),
        )
        ?.map((product: any) => {
          return (
            <SwiperSlide key={product.objectID}>
              <ProducItem hit={product} isPLP={false} isCarousel={true} />
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};

export default AlgoliaRecommendProductsList;
